import { render, staticRenderFns } from "./SectionList.html?vue&type=template&id=5bdec416&scoped=true&external"
import script from "./SectionList.ts?vue&type=script&lang=ts&external"
export * from "./SectionList.ts?vue&type=script&lang=ts&external"
import style0 from "./SectionList.scss?vue&type=style&index=0&id=5bdec416&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdec416",
  null
  
)

export default component.exports